import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {environment} from "@app/environment";
import {catchError, map, Observable, of, tap, throwError} from "rxjs";
import {User} from "../../../core/_datamodel/user";
import {plainToInstance} from "class-transformer";
import {CosoPrompt} from "./datamodel";

@Injectable({
  providedIn: 'root',
})
export class CosoPromptsService {
  options: any = {
    // withCredentials: true,
    headers: new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('api-key', environment.API_KEY)
      .set('ngsw-bypass', 'true')
  };
  cosoOptions: any = {
    // withCredentials: true,
    headers: new HttpHeaders().set('Content-Type', 'application/json')
      .set('api-key', environment.COSO_API_KEY)
      .set('ngsw-bypass','true')
  };

  constructor(private http: HttpClient) {
    if(!environment.production) { console.debug('Prompts Service instanced!'); }
  }

  // This is the one called by the coso-chat components
  getChatCosoPrompts(user: User): Observable<CosoPrompt[]> {
    return this.http.post(environment.COSO_API_URL + '/getCosoPrompts', {user}, this.cosoOptions).pipe(
      tap((data: any) => {
        if (!environment.production) console.debug('getChatCosoPrompts loaded:', data);
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(CosoPrompt, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  // This is the one called by the coso-prompts components
  getCosoPrompts(user: User): Observable<CosoPrompt[]> {
    return this.http.post(environment.API_URL + '/coso/getCosoPrompts', {user}, this.options).pipe(
      tap((data: any) => {
        if (!environment.production) console.debug('getCosoPrompts loaded:', data);
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(CosoPrompt, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  getCosoPrompt(coso_prompts_id: number, user: User): Observable<CosoPrompt> {
    return this.http.post(environment.API_URL + '/coso/getCosoPrompt', {coso_prompts_id, user}, this.options).pipe(
      tap((data: any) => {
        if (!environment.production) console.debug('getCosoPrompt loaded:', data);
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(CosoPrompt, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  createCosoPrompt(prompt: CosoPrompt): Observable<CosoPrompt> {
    return this.http.post(environment.API_URL + '/coso/createCosoPrompt', prompt, this.options).pipe(
      tap(() => {
        if (!environment.production) {
          console.debug('createCosoPrompt success');
        }
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(CosoPrompt, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  saveCosoPrompt(prompt: CosoPrompt): Observable<CosoPrompt> {
    return this.http.post(environment.API_URL + '/coso/saveCosoPrompt', prompt, this.options).pipe(
      tap(() => {
        if (!environment.production) {
          console.debug('saveCosoPrompt success');
        }
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(CosoPrompt, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  deleteCosoPrompt(prompt: CosoPrompt, user: User): Observable<null> {
    return this.http.post(environment.API_URL + '/coso/deleteCosoPrompt', {prompt, user}, this.options).pipe(
      tap(() => {
        if (!environment.production) {
          console.debug('deleteCosoPrompt success');
        }
      }),
      map((data: any) => {
        // @ts-ignore
        return plainToInstance(CosoPrompt, data);
      }),
      catchError(err => {
        if (err.status === 401) {
          console.warn(err.error.message);
          return of(err);
        } else {
          return this.handleError(err);
        }
      })
    );
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage;
    if (err.error instanceof Error) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = err.error.message;
    }
    console.error(errorMessage);
    return throwError(() => {
      return new Error(errorMessage)
    });
  }
}
